export const BoxVariant = {
    super: 'super',
    quiet: 'quiet',
    subtle: 'subtle',
    caution: 'caution',
    background: 'background',
    inverse: 'inverse',
    raised: 'raised',
};
//# sourceMappingURL=BoxVariant.js.map